// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookDetails_main_container__ViUa1 {
  width: 100%;
  background: #1a1a1a;
  padding-top: 5rem;
}

.BookDetails_container__L4TO6 {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  color: white;
}

.BookDetails_header__Ei5s3 {
  display: flex;
  gap: 30px;
  margin-bottom: 40px;
}

.BookDetails_coverWrapper__FCXx7 {
  flex: 0 0 300px;
}

.BookDetails_cover__IF1eK {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
}

.BookDetails_info__cN-B7 {
  flex: 1 1;
}

.BookDetails_title__pCN2K {
  font-size: 32px;
  margin: 0 0 10px 0;
}

.BookDetails_author__PEA77 {
  color: #888;
  margin-bottom: 20px;
}

.BookDetails_stats__6S2tE {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
}

.BookDetails_stat__iDu3A {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BookDetails_icon__LmJ7z {
  font-size: 20px;
}

.BookDetails_readButton__o05ur {
  background: #e50914;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}
.BookDetails_addLibrarybutton__BFFSW {
  background: white;
  color: black;
  border: none;
  padding: 12px 13px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}
.BookDetails_addButton__MqeZP{
  color: white;
}

.BookDetails_readButton__o05ur:hover {
  background: #f40d17;
}

.BookDetails_episodesSection__nOSuW {
  margin-top: 40px;
}

.BookDetails_episodesTitle__xE1Bn {
  font-size: 24px;
  margin-bottom: 20px;
}

.BookDetails_episodesGrid__jmaog {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 10px 0;
}

.BookDetails_episodeCard__o-xUN {
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease;
  display: flex;
  padding: 10px 10px;
  background-color: #3d3a3a8a
}

.BookDetails_episodeCard__o-xUN:hover {
  transform: translateY(-5px);
}

.BookDetails_episodeImageWrapper__Nyf13 {
  overflow: hidden;
  width: 40%;
}

.BookDetails_episodeImage__0g-NG {
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
  cursor: pointer;
  border-radius: 0px;
}

.BookDetails_episodeCard__o-xUN:hover .BookDetails_episodeImage__0g-NG {
  transform: scale(1.05);
}

.BookDetails_episodeInfo__TVoPq {
  padding: 15px;
  width: 38%;
}

.BookDetails_episodeName__nHlkI {
  margin: 0 0 5px 0;
  font-size: 18px;
}

.BookDetails_episodeSubtitle__6u2Nb {
  color: #888;
  margin: 0;
  font-size: 14px;
}

.BookDetails_notFound__WvO\\+\\+ {
  text-align: center;
  padding: 50px;
  font-size: 24px;
  color: white;
}

/* Responsive styles */
@media (max-width: 828px) {
  .BookDetails_header__Ei5s3 {
    flex-direction: column;
  }

  .BookDetails_coverWrapper__FCXx7 {
    flex: none;
    max-width: 250px;
    margin: 0 auto;
  }
 .BookDetails_stat__iDu3A {
    flex: 1 1 40%;
  }

  .BookDetails_episodesGrid__jmaog {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
  .BookDetails_info__cN-B7 {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .BookDetails_title__pCN2K {
    font-size: 24px;
  }
  .BookDetails_episodeCard__o-xUN{
    padding: 5px 5px;
  }
.BookDetails_episodeImage__0g-NG{
  object-fit: contain;
}
  .BookDetails_stat__iDu3A {
    flex: 1 1 100%;
  }
  .BookDetails_coverWrapper__FCXx7 {
    max-width: 200px;
    margin: 0 auto;
  }

  .BookDetails_episodesGrid__jmaog {
    grid-template-columns: repeat(2,1fr);
  }
  .BookDetails_addLibrarybutton__BFFSW {
    margin-top: 1rem;
  }
  .BookDetails_episodeName__nHlkI{
    font-size: 12px;
  }
  .BookDetails_episodeSubtitle__6u2Nb{
    font-size: 8px;
  }
}
/* Add these styles to your BookDetails.module.css file */

.BookDetails_likeButton__Q4Gg5 {
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.BookDetails_likeButton__Q4Gg5:hover {
  transform: scale(1.05);
}

.BookDetails_likeButton__Q4Gg5:active {
  transform: scale(0.95);
}

.BookDetails_heartIcon__WymEK {
  margin-right: 5px;
  transition: all 0.3s ease;
}

.BookDetails_liked__nd8Mt {
  animation: BookDetails_pulse__h1Q2F 0.4s ease-out;
}

@keyframes BookDetails_pulse__h1Q2F {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/view/BookDetails.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,cAAc;EAChB;CACD;IACG,aAAa;EACf;;EAEA;IACE,4DAA4D;EAC9D;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;EACE,mBAAmB;AACrB;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,oCAAoC;EACtC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;AACF;AACA,yDAAyD;;AAEzD;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iDAA8B;AAChC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".main_container {\n  width: 100%;\n  background: #1a1a1a;\n  padding-top: 5rem;\n}\n\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 20px;\n  color: white;\n}\n\n.header {\n  display: flex;\n  gap: 30px;\n  margin-bottom: 40px;\n}\n\n.coverWrapper {\n  flex: 0 0 300px;\n}\n\n.cover {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.info {\n  flex: 1;\n}\n\n.title {\n  font-size: 32px;\n  margin: 0 0 10px 0;\n}\n\n.author {\n  color: #888;\n  margin-bottom: 20px;\n}\n\n.stats {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 30px;\n}\n\n.stat {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.icon {\n  font-size: 20px;\n}\n\n.readButton {\n  background: #e50914;\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n.addLibrarybutton {\n  background: white;\n  color: black;\n  border: none;\n  padding: 12px 13px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n.addButton{\n  color: white;\n}\n\n.readButton:hover {\n  background: #f40d17;\n}\n\n.episodesSection {\n  margin-top: 40px;\n}\n\n.episodesTitle {\n  font-size: 24px;\n  margin-bottom: 20px;\n}\n\n.episodesGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n  padding: 10px 0;\n}\n\n.episodeCard {\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  display: flex;\n  padding: 10px 10px;\n  background-color: #3d3a3a8a\n}\n\n.episodeCard:hover {\n  transform: translateY(-5px);\n}\n\n.episodeImageWrapper {\n  overflow: hidden;\n  width: 40%;\n}\n\n.episodeImage {\n  width: 100%;\n  height: 100%;\n  transition: transform 0.3s ease;\n  cursor: pointer;\n  border-radius: 0px;\n}\n\n.episodeCard:hover .episodeImage {\n  transform: scale(1.05);\n}\n\n.episodeInfo {\n  padding: 15px;\n  width: 38%;\n}\n\n.episodeName {\n  margin: 0 0 5px 0;\n  font-size: 18px;\n}\n\n.episodeSubtitle {\n  color: #888;\n  margin: 0;\n  font-size: 14px;\n}\n\n.notFound {\n  text-align: center;\n  padding: 50px;\n  font-size: 24px;\n  color: white;\n}\n\n/* Responsive styles */\n@media (max-width: 828px) {\n  .header {\n    flex-direction: column;\n  }\n\n  .coverWrapper {\n    flex: none;\n    max-width: 250px;\n    margin: 0 auto;\n  }\n .stat {\n    flex: 1 1 40%;\n  }\n\n  .episodesGrid {\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  }\n  .info {\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .title {\n    font-size: 24px;\n  }\n  .episodeCard{\n    padding: 5px 5px;\n  }\n.episodeImage{\n  object-fit: contain;\n}\n  .stat {\n    flex: 1 1 100%;\n  }\n  .coverWrapper {\n    max-width: 200px;\n    margin: 0 auto;\n  }\n\n  .episodesGrid {\n    grid-template-columns: repeat(2,1fr);\n  }\n  .addLibrarybutton {\n    margin-top: 1rem;\n  }\n  .episodeName{\n    font-size: 12px;\n  }\n  .episodeSubtitle{\n    font-size: 8px;\n  }\n}\n/* Add these styles to your BookDetails.module.css file */\n\n.likeButton {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s ease;\n}\n\n.likeButton:hover {\n  transform: scale(1.05);\n}\n\n.likeButton:active {\n  transform: scale(0.95);\n}\n\n.heartIcon {\n  margin-right: 5px;\n  transition: all 0.3s ease;\n}\n\n.liked {\n  animation: pulse 0.4s ease-out;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_container": `BookDetails_main_container__ViUa1`,
	"container": `BookDetails_container__L4TO6`,
	"header": `BookDetails_header__Ei5s3`,
	"coverWrapper": `BookDetails_coverWrapper__FCXx7`,
	"cover": `BookDetails_cover__IF1eK`,
	"info": `BookDetails_info__cN-B7`,
	"title": `BookDetails_title__pCN2K`,
	"author": `BookDetails_author__PEA77`,
	"stats": `BookDetails_stats__6S2tE`,
	"stat": `BookDetails_stat__iDu3A`,
	"icon": `BookDetails_icon__LmJ7z`,
	"readButton": `BookDetails_readButton__o05ur`,
	"addLibrarybutton": `BookDetails_addLibrarybutton__BFFSW`,
	"addButton": `BookDetails_addButton__MqeZP`,
	"episodesSection": `BookDetails_episodesSection__nOSuW`,
	"episodesTitle": `BookDetails_episodesTitle__xE1Bn`,
	"episodesGrid": `BookDetails_episodesGrid__jmaog`,
	"episodeCard": `BookDetails_episodeCard__o-xUN`,
	"episodeImageWrapper": `BookDetails_episodeImageWrapper__Nyf13`,
	"episodeImage": `BookDetails_episodeImage__0g-NG`,
	"episodeInfo": `BookDetails_episodeInfo__TVoPq`,
	"episodeName": `BookDetails_episodeName__nHlkI`,
	"episodeSubtitle": `BookDetails_episodeSubtitle__6u2Nb`,
	"notFound": `BookDetails_notFound__WvO++`,
	"likeButton": `BookDetails_likeButton__Q4Gg5`,
	"heartIcon": `BookDetails_heartIcon__WymEK`,
	"liked": `BookDetails_liked__nd8Mt`,
	"pulse": `BookDetails_pulse__h1Q2F`
};
export default ___CSS_LOADER_EXPORT___;
